import { LogoIcon } from "./LogoIcon";
import { cn } from "@/lib/utils";

type LogoSize = "sm" | "md" | "lg" | "xl";
type LogoVariant = "primary" | "gradient" | "dark" | "white";
type LogoLayout = "horizontal" | "vertical" | "icon-only";

interface LogoProps {
  size?: LogoSize;
  variant?: LogoVariant;
  layout?: LogoLayout;
  className?: string;
}

const sizeClasses = {
  sm: {
    icon: "w-6 h-6",
    text: "text-lg",
    gap: "gap-2",
  },
  md: {
    icon: "w-8 h-8",
    text: "text-2xl",
    gap: "gap-2.5",
  },
  lg: {
    icon: "w-12 h-12",
    text: "text-3xl",
    gap: "gap-3",
  },
  xl: {
    icon: "w-16 h-16",
    text: "text-5xl",
    gap: "gap-4",
  },
};

const variantClasses = {
  primary: "text-primary",
  gradient: "bg-gradient-to-r from-primary to-red-500 bg-clip-text text-transparent",
  dark: "text-slate-900",
  white: "text-white",
};

export const Logo = ({
  size = "md",
  variant = "primary",
  layout = "horizontal",
  className,
}: LogoProps) => {
  const sizes = sizeClasses[size];
  
  // Icon only layout
  if (layout === "icon-only") {
    return (
      <LogoIcon
        variant={variant}
        className={cn(sizes.icon, className)}
      />
    );
  }

  // Horizontal layout
  if (layout === "horizontal") {
    return (
      <div className={cn("flex items-center", sizes.gap, className)}>
        <LogoIcon
          variant={variant}
          className={sizes.icon}
        />
        <span
          className={cn(
            "font-bold",
            sizes.text,
            variant === "gradient" ? variantClasses.gradient : variantClasses[variant]
          )}
        >
          Fulltrúi
        </span>
      </div>
    );
  }

  // Vertical layout
  return (
    <div className={cn("flex flex-col items-center", sizes.gap, className)}>
      <LogoIcon
        variant={variant}
        className={sizes.icon}
      />
      <span
        className={cn(
          "font-bold",
          sizes.text,
          variant === "gradient" ? variantClasses.gradient : variantClasses[variant]
        )}
      >
        Fulltrúii
      </span>
    </div>
  );
};
